import vuetify from '@/plugins/vuetify';

/**
 * Sync Vuex isDarkMode → Vuetify 3 theme (replaces Vue 2 `$darkMode` prototype setter).
 */
export function setDarkMode(isDark) {
  vuetify.theme.change(isDark ? 'dark' : 'light');
}

export function installDarkModeHelper(app) {
  app.config.globalProperties.$setDarkMode = setDarkMode;

  // Kept for any leftover template reads; prefer `$store.state.isDarkMode` for reactivity.
  Object.defineProperty(app.config.globalProperties, '$darkMode', {
    get() {
      return vuetify.theme.global.name.value === 'dark';
    },
    set(value) {
      setDarkMode(value);
    },
  });
}
